import React from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

interface Props {
  onClick?:
    | ((event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void)
    | undefined;
  className?: string;
  size?: FontAwesomeIconProps['size'];
  disabled?: boolean;
}
const CaretLeftIcon: React.FC<Props> = ({
  onClick,
  className,
  size,
  disabled
}: Props): JSX.Element => (
  <FontAwesomeIcon
    size={size || '1x'}
    className={disabled ? className + ' disabled' : className}
    icon={faCaretLeft}
    onClick={onClick}
  />
);

export default React.memo(CaretLeftIcon);
